import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

let _cache = null;
let _inflight = null;

async function load() {
  if (_cache) return _cache;
  if (!_inflight) {
    _inflight = axios
      .get(`${API}/config`)
      .then((res) => {
        _cache = res.data || {};
        return _cache;
      })
      .catch(() => {
        _cache = {};
        return _cache;
      })
      .finally(() => { _inflight = null; });
  }
  return _inflight;
}

export function usePublicConfig() {
  const [config, setConfig] = useState(_cache);
  useEffect(() => {
    let alive = true;
    if (_cache) { setConfig(_cache); return; }
    load().then((data) => { if (alive) setConfig(data); });
    return () => { alive = false; };
  }, []);
  return config || {};
}
